"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsIntegrationDataFulfilled = exports.getIsIntegrationDataPending = void 0;

var _reselect = require("reselect");

var _settings = require("../../Shared/Teams/store/settings/settings.selectors");

var _integrations = require("../../Shared/Users/store/integrations/integrations.selectors");

var getIsIntegrationDataPending = (0, _reselect.createSelector)(_settings.getIsPending, _integrations.getIsPending, function (isTeamSettingsPending, isIntegrationSettingsPending) {
  return isTeamSettingsPending || isIntegrationSettingsPending;
});
exports.getIsIntegrationDataPending = getIsIntegrationDataPending;
var getIsIntegrationDataFulfilled = (0, _reselect.createSelector)(_settings.getIsFulfilled, _integrations.getIsFulfilled, function (isTeamSettingsFulfilled, isIntegrationSettingsFulfilled) {
  return isTeamSettingsFulfilled && isIntegrationSettingsFulfilled;
});
exports.getIsIntegrationDataFulfilled = getIsIntegrationDataFulfilled;